export default class Helpers {
    static findJerseyImageModule(team, brand) {
        const formattedTeamName = this.formatTextForAssetNames(team);
        const possibleFormats = ['png', 'webp'];

        for (const format of possibleFormats) {
            try {
                return require(`../assets/jerseys/${formattedTeamName}-kit.${format}`);
            } catch (e) {
            }
        }

        return require(`../brand/${brand}/assets/jerseys/default-player-jersey.webp`);
    }

    static findLeagueImageModule(league) {
        const name = typeof league === "object" ? league.leagueName : league;
        const reformattedLeagueName = this.formatTextForAssetNames(name);
        const possibleFormats = ['webp', 'png'];

        for (const format of possibleFormats) {
            try {
                return require(`../assets/leagueLogos/${reformattedLeagueName}-logo-colour.${format}`);
            } catch (e) {
            }
        }

        return require('../assets/default-badge.webp');
    }

    static findTeamImageModule(teamName) {
        const reformattedTeamName = this.formatTextForAssetNames(teamName);
        const possibleFormats = ['jpeg', 'jpg', 'png', 'webp'];

        for (const format of possibleFormats) {
            try {
                return require(`../assets/teamBadges/${reformattedTeamName}-logo-icon.${format}`);
            } catch (e) {
            }
        }
        return require('../assets/default-badge.webp');
    }

    static formatTextForAssetNames(text) {
        const lowerCase = text.toLowerCase();
        return lowerCase.replaceAll(' ', '-');
    }

    static getLogoPath(brand, size = 'sml') {
        const logoName = `logo-${size}`;
        const wpBrands = ['wp-za-en', 'telkom-wp-za-en', 'mtn-wp-za-en'];
        
        // For WP brands, use PNG
        if (wpBrands.includes(brand)) {
            if (brand === 'wp-za-en') {
                if (size === 'sml') return require(`../brand/wp-za-en/assets/illustrations/logo-sml.png`);
                if (size === 'md') return require(`../brand/wp-za-en/assets/illustrations/logo-md.png`);
                if (size === 'lrg') return require(`../brand/wp-za-en/assets/illustrations/logo-lrg.png`);
            } else if (brand === 'telkom-wp-za-en') {
                if (size === 'sml') return require(`../brand/telkom-wp-za-en/assets/illustrations/logo-sml.png`);
                if (size === 'md') return require(`../brand/telkom-wp-za-en/assets/illustrations/logo-md.png`);
                if (size === 'lrg') return require(`../brand/telkom-wp-za-en/assets/illustrations/logo-lrg.png`);
            } else if (brand === 'mtn-wp-za-en') {
                if (size === 'sml') return require(`../brand/mtn-wp-za-en/assets/illustrations/logo-sml.png`);
                if (size === 'md') return require(`../brand/mtn-wp-za-en/assets/illustrations/logo-md.png`);
                if (size === 'lrg') return require(`../brand/mtn-wp-za-en/assets/illustrations/logo-lrg.png`);
            }
        }
        
        // For other brands, use webp (fallback to default if brand not found)
        try {
            return require(`../brand/${brand}/assets/illustrations/${logoName}.webp`);
        } catch (e) {
            return require(`../brand/vc-za-en/assets/illustrations/logo-${size}.webp`);
        }
    }
}
